import React, { useState, useEffect } from "react";
import Icon from "../AppIcon";

const WorkflowProgressIndicator = ({
  currentPhase = "survey",
  completionData = {},
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const phases = [
    {
      id: "survey",
      label: "Survey",
      icon: "ClipboardList",
      description: "Site & Roof Assessment",
    },
    {
      id: "civil",
      label: "Civil Work",
      icon: "HardHat",
      description: "Foundation & Structure",
    },
    {
      id: "technical",
      label: "Technical",
      icon: "Wrench",
      description: "Installation & Testing",
    },
  ];

  const getPhaseStatus = (phaseId) => {
    const currentIndex = phases?.findIndex((p) => p?.id === currentPhase);
    const phaseIndex = phases?.findIndex((p) => p?.id === phaseId);

    if (phaseIndex < currentIndex) return "completed";
    if (phaseIndex === currentIndex) return "active";
    return "pending";
  };

  const getCompletionPercentage = (phaseId) => {
    return completionData?.[phaseId] || 0;
  };

  return (
    <div className="workflow-progress">
      <div className="workflow-progress-container">
        <div className="workflow-progress-steps">
          {phases?.map((phase, index) => {
            const status = getPhaseStatus(phase?.id);
            const completion = getCompletionPercentage(phase?.id);

            return (
              <React.Fragment key={phase?.id}>
                <div className={`workflow-progress-step ${status}`}>
                  <div className="workflow-progress-step-indicator">
                    {status === "completed" ? (
                      <Icon name="Check" size={isMobile ? 16 : 20} />
                    ) : (
                      <Icon name={phase?.icon} size={isMobile ? 16 : 20} />
                    )}
                  </div>
                  <div className="flex flex-col items-center gap-1">
                    <span className="workflow-progress-step-label">
                      {phase?.label}
                    </span>
                    {status === "active" && completion > 0 && (
                      <span className="text-[10px] font-medium text-primary">
                        {completion}%
                      </span>
                    )}
                    {!isMobile && (
                      <span className="text-[10px] text-muted-foreground">
                        {phase?.description}
                      </span>
                    )}
                  </div>
                </div>
                {index < phases?.length - 1 && (
                  <div
                    className={`workflow-progress-connector ${
                      status === "completed" ? "completed" : ""
                    }`}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WorkflowProgressIndicator;
